import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-text-large',
    templateUrl: './text-large.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextLargeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
